@if (imageUrl) {
  <div class="container pt-3">
    @if (showImage) {
      <img [src]="imageUrl" alt="Downloaded Image" />
    }
    <button class="btn btn-primary" (click)="downloadImage()">{{"DOWNLOAD"|translate}}</button>
  </div>
}
